import React, { useEffect, useState, useRef } from "react";
import MainPage from "../../Components/MainPage";
import Prince from "../../Components/Prince";
import DropdownMenu from "../../Components/DropdownMenu";
import { Button } from "bootstrap";
import TopHeader from "../../Components/TopHeader";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Prompt from "../../Components/Promt";
import { format } from "date-fns";
import { DateRangePicker } from "react-date-range";
import spiner from "../../assets/img/spiner.gif";
import Loader from "../../assets/img/loader.gif";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
//import Select from "@mui/material/Select";
import SelectComponent from "../Sales CRM/SelectComponent";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Select from "@mui/joy/Select";
import Option from "@mui/joy/Option";
//import Select from "@mui/material";
//import Pagination from "@mui/material";
//import Option from "@mui/material";
// import Table from "react-bootstrap/Table";
const Token = localStorage.getItem("_ux98c_v1");
const apiUrl = process.env.REACT_APP_URL;
//console.log(apiUrl);

function MonthlyData() {
  const [fromDate, setFromDate] = useState("");
  const [totalPages, setTotalPages] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [loader, setLoader] = useState(true);
  const [toDate, setToDate] = useState("");
  const [from, setFrom] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  // const [date, setDate] = useState({
  //   startDate: new Date(),
  //   endDate: new Date(),
  //   key: "selection",
  // });
  const [date, setDate] = useState(null);

  const [customerOptions, setCustomerOptions] = useState([]);
  const [applyFilter, setApplyFilter] = useState(false);
  const [selectedYear, setSelectedYear] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerData, setCustomerData] = useState([]);
  const { customerId } = useParams();
  const [isModalOpen, setIsModalOpen] = useState(false);
  // console.log("Token:", Token);
  const [monthData, setMonthData] = useState([]);
  const [dropDownYear, setDropDownYear] = useState([]);
  const [search, setSearch] = useState("");
  const [dateFilterModalOPen, setDateFilterModalOpen] = useState(false);
  const [filterByBusinessCategory, setFilterByBusinessCategory] = useState([]);
  const [filterByObj, setFilterByObj] = useState({
    leadSource: "",
    leadPipeline: "",
    businessCategory: "",
    shipmentPotential: "",
    clientPersona: "",
    partner: "",
    to: "",
    from: "",
    search: "",
    isKycDone: "",
    minimumExpectedShipmentToFship: "",
    employeeId: "",
    genericEmailPattern: "",
  });

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  //const [loader, setLoader] = useState(false);

  const handleLoader = () => {
    setLoader(true);
    setTimeout(() => {
      setLoader(false);
    }, 1000);
  };

  const handlePageChange = (event, newPage) => {
    if (newPage) {
      setCurrentPage(newPage); // Assuming setCurrentPage is a state setter
      scrollToTop(); // Assuming this function scrolls the page to the top
    } else {
      setCurrentPage(1); // Fallback to page 1 if newPage is undefined
    }
  };

  // console.log(currentPage);
  const handlePageSize = (value) => {
    setPageSize(value.target.innerText);
    scrollToTop();
  };

  console.log(pageSize);
  // const years = [...new Set(dropDownYear.map((item) => item.year))]; // Assuming your data has a 'year' property
  function adjustDateAndExtractMonthYear(dateString) {
    // Parse the date string
    let date = new Date(dateString);

    // Add one day to the date
    date.setDate(date.getDate() + 1);

    // Extract the month and year
    const month = date.getUTCMonth() + 1; // getUTCMonth() returns 0-11, so add 1 to get 1-12
    const year = date.getUTCFullYear();

    return { month, year };
  }

  const handleCustomerChange = (e) => {
    setSelectedYear(e.target.value);
    // setCustomerName(customerId);
  };
  // console.log(selectedYear);
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  const handleOpenModal = (e) => {
    e.preventDefault();
    setIsModalOpen(true);
    document.body.classList.add("modal-open");

    const url = window.location.href.includes("all-report")
      ? `${apiUrl}/customer/monthlyReportExport?customerId=${selectedYear}&from=${fromDate}&to=${toDate}`
      : `${apiUrl}/customer/monthlyReportExport?customerId=${
          customerId == undefined ? "" : customerId
        }&from=${fromDate}&to=${toDate}`;
    // IMPORT
    fetch(url, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          // console.log(data.data.fileURL);
          setFrom(data.data.fileURL);
        }
      });
  };

  const handleConfirm = () => {
    window.location.href = from;

    setIsModalOpen(false);
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  };

  const handleDateChange = (ranges) => {
    const formatToISOString = (date) => {
      return new Date(
        date.getTime() - date.getTimezoneOffset() * 60000
      ).toISOString();
    };

    const startDate = new Date(ranges.selection.startDate);
    const endDate = new Date(ranges.selection.endDate);

    setToDate(formatToISOString(startDate));
    setFromDate(formatToISOString(endDate));
    setFilterByObj({
      ...filterByObj,
      to: formatToISOString(endDate),
      from: formatToISOString(startDate),
    });

    setDate(ranges.selection);

    // Automatically close modal if endDate is selected and not same as startDate
    if (startDate && endDate && startDate.getTime() !== endDate.getTime()) {
      handleCloseDateFilterModal();
    }
  };

  const handleCloseDateFilterModal = () => {
    setDateFilterModalOpen(false);
  };
  const handleDateFilterClick = () => {
    setDateFilterModalOpen(true);
  };
  const capitalizeFirstLetterOfEachWord = (str) => {
    return str?.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const handleApplyFilter = () => {
    setApplyFilter(!applyFilter);
  };

  function getMonthName(monthNumber) {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    // Ensure monthNumber is within valid range
    if (monthNumber < 1 || monthNumber > 12) {
      return "Invalid month";
    }

    return months[monthNumber - 1];
  }
  const adjustFromDate = adjustDateAndExtractMonthYear(fromDate);
  const adjustToDate = adjustDateAndExtractMonthYear(toDate);
  useEffect(() => {
    const Token = localStorage.getItem("_ux98c_v1");

    fetch(`${apiUrl}/customer/customerDropdown`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          if (Array.isArray(data.data)) {
            setCustomerOptions(
              data.data.map((item) => ({
                id: item.id,
                name: `${item.primaryContactName}(${item.id})`,
              }))
            );
          } else {
            console.error("API response does not contain users array:", data);
          }
        } else {
          console.error("API request was not successful:", data);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);
  useEffect(() => {
    // Make an API request to fetch gender options
    fetch(`${apiUrl}/customer/customerList`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setCustomerData(data.data);
          // console.log(data.data);
        } else {
          console.error("API response does not contain an array:", data);
        }
      })
      .catch((error) => {
        console.error("Error fetching gender options:", error);
      });
  }, []);

  // console.log(customerData);
  function getReport() {
    setLoader(true);
    const url = window.location.href.includes("all-report")
      ? `${apiUrl}/customer/allShipmentReport?customerId=${selectedYear}&from=${fromDate}&to=${toDate}&page=${currentPage}&pageSize=${pageSize}`
      : `${apiUrl}/customer/allShipmentReport?customerId=${
          customerId == undefined ? "" : customerId
        }&from=${fromDate}&to=${toDate}&page=${1}&pageSize=${10}`;
    fetch(
      // `${apiUrl}/customer/allShipmentReport?customerId=${selectedYear}&from=${`${adjustFromDate.month} ${adjustFromDate.year}`}&to=${`${adjustToDate.month} ${adjustToDate.year}`}`,
      url,
      {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        // Handle the retrieved data here
        //   console.log(data);
        setMonthData(data.data);
        // setDropDownYear(data.data.monthRecords);
        const totalCount = data.totalCount;
        setTotalPages(Math.ceil(totalCount / pageSize));
        // console.log("Data:", data);
        setTimeout(() => {
          setLoaded(true);
        }, 800);
        setLoader(false);
      })
      .catch((error) => {
        // Handle errors here

        console.error("Error:", error);
      });
  }
  // console.log(monthData);

  // useEffect(() => {
  //   getReport();
  // }, [currentPage, applyFilter]);

  function getYearList() {
    setLoader(true);
    fetch(
      `${apiUrl}/customer/allShipmentReport?customerId=${
        customerId == undefined ? "" : customerId
      }&from=${filterByObj.from}&to=${filterByObj.to}`,
      {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        // Handle the retrieved data here
        // setMonthData(data.data.monthRecords);
        setDropDownYear(data.data.monthRecords);
        // console.log("Data:", data);
        setTimeout(() => {
          setLoaded(true);
        }, 800);
        setLoader(false);
      })
      .catch((error) => {
        // Handle errors here

        console.error("Error:", error);
      });
  }
  useEffect(() => {
    getYearList();
  }, []);

  useEffect(() => {
    getReport();
  }, [fromDate, toDate, currentPage, applyFilter]);

  const currentValue = window.location.href?.includes("all-report")
    ? selectedYear
    : customerId;

  const handleCheckboxChange2 = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    const id = selectedOptions
      ? selectedOptions.map((option) => option.id)
      : [];
    //setFilterByLeadPipeline(values);
    setFilterByBusinessCategory(values);
    setSelectedYear(id);
  };
  // console.log(customerOptions);
  return (
    <div className="page">
      <TopHeader />
      <Prince />
      <div className="main-content side-content pt-0 m-0">
        <div className="main-container container-fluid">
          <div className="inner-body">
            <div className="page-header">
              <div>
                <h2 className="main-content-title tx-24 mg-b-5">
                  Monthly Report
                </h2>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a>Report</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Customer Id: {customerId}
                  </li>
                </ol>
              </div>
            </div>
            <div style={{ marginTop: "30px" }}>
              <div
                className="row "
                style={{ marginLeft: "0", marginRight: "0" }}
              >
                <div className="card custom-card">
                  <div className="card-body py-3">
                    <div className="row">
                      {" "}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        {/* <div> */}
                        <SelectComponent
                          label="Customers"
                          options={customerOptions}
                          handleSelectChange={handleCheckboxChange2}
                          selectedOptions={filterByBusinessCategory}
                        />
                        {/* </div> */}
                        <div
                          // className="d-flex"
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginTop: "50px",
                          }}
                        >
                          {" "}
                          {/* </div> */}
                          <button
                            style={{
                              marginLeft: "12px",
                              fontSize: "12px",
                              height: "20px",
                            }}
                            onClick={handleDateFilterClick}
                            className="btn btn-light"
                          >
                            {date
                              ? `${format(
                                  date.startDate,
                                  "MMM dd yyyy"
                                )} -- ${format(date.endDate, "MMM dd yyyy")}`
                              : "Select Calender Date"}
                          </button>
                          <div style={{ height: "20px" }}>
                            <button
                              style={{ marginLeft: "12px" }}
                              onClick={handleApplyFilter}
                              className="btn btn-outline-success"
                            >
                              Apply Filter
                            </button>
                            <button
                              style={{ marginLeft: "12px" }}
                              onClick={() => {
                                // setDate({
                                //   startDate: new Date(),
                                //   endDate: new Date(),
                                //   key: "selection",
                                // });
                                window.location.reload();
                              }}
                              // className="btn btn-light"
                              className="btn btn-outline-secondary"
                            >
                              Clear Filter
                            </button>
                          </div>
                          <div style={{ height: "20px" }}>
                            <button
                              style={{ marginLeft: "12px" }}
                              onClick={handleOpenModal}
                              // className="btn btn-light"
                              className="btn btn-outline-info"
                            >
                              Export
                            </button>
                            <div
                              className={`modal ${
                                isModalOpen ? "show" : ""
                              } bg-black-7`}
                              style={{
                                display: isModalOpen ? "block" : "none",
                              }}
                              tabIndex="-1"
                              role="dialog"
                            >
                              <div
                                className="modal-dialog modal-dialog-centered modal-xl"
                                role="document"
                              >
                                <div className="modal-content rounded-3">
                                  <div className="modal-header">
                                    <h5 className="modal-title">
                                      download excel
                                    </h5>
                                    <button
                                      type="button"
                                      className="close"
                                      data-dismiss="modal"
                                      aria-label="Close"
                                      onClick={handleCloseModal}
                                    >
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>

                                  <div
                                    className="modal-body "
                                    style={{ width: "100%" }}
                                  >
                                    {from !== "" ? (
                                      <p>Click here to download</p>
                                    ) : (
                                      <p>
                                        Please wait , Download button will
                                        appear soon...{" "}
                                      </p>
                                    )}
                                    {from !== "" ? (
                                      <button
                                        className="btn ripple btn-primary"
                                        type="button"
                                        onClick={handleConfirm}
                                      >
                                        Download
                                      </button>
                                    ) : (
                                      <img src={spiner} height={"50px"}></img>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className={`modal ${
                          dateFilterModalOPen ? "show" : ""
                        } bg-black-7`}
                        style={{
                          display: dateFilterModalOPen ? "block" : "none",
                        }}
                        tabIndex="-1"
                        role="dialog"
                      >
                        <div
                          className="modal-dialog modal-dialog-centered modal-xl"
                          role="document"
                        >
                          <div className="modal-content rounded-3">
                            <div className="modal-header">
                              <h5 className="modal-title">Select Date Range</h5>
                              <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={handleCloseDateFilterModal}
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>

                            <div
                              className="modal-body"
                              style={{ width: "100%" }}
                            >
                              <DateRangePicker
                                // ranges={[date]}
                                ranges={
                                  date
                                    ? [date]
                                    : [
                                        {
                                          startDate: new Date(),
                                          endDate: new Date(),
                                          key: "selection",
                                        },
                                      ]
                                }
                                onChange={handleDateChange}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {loader ? (
                      <div className="loading-overlay">
                        <img src={Loader} alt="Loading..." />
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>{" "}
                </div>
              </div>
            </div>
            {/* Row */}
          </div>
          {/* popup */}

          <div className="bg-white  rounded-3">
            <div
              style={{
                textAlign: "center",
                marginTop: "30px",
                backgroundColor: "#F7418F",
                paddingTop: "10px",
                color: "#fff",
                fontWeight: "600",
                paddingBottom: "8px",
              }}
            >
              <h3>Customer Order Report</h3>
            </div>

            {loaded ? (
              <>
                <div className="p-4 mt-3 mb-3">
                  {" "}
                  <TableContainer component={Paper}>
                    <Table
                      sx={{ minWidth: 650 }}
                      size="small"
                      aria-label="a dense table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell align="center">ID</TableCell>
                          <TableCell align="center">CUSTOMER NAME</TableCell>
                          <TableCell align="center">COMPANY ID</TableCell>
                          <TableCell align="center">TOTAL ORDER</TableCell>
                          <TableCell align="center">TOTAL SHIPMENT</TableCell>
                          <TableCell align="center">MONTH</TableCell>
                          <TableCell align="center">YEAR</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {monthData?.map((row) => (
                          <TableRow
                            key={row.id}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <TableCell
                              component="th"
                              scope="row"
                              align="center"
                            >
                              {row.id}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              align="center"
                            >
                              {capitalizeFirstLetterOfEachWord(
                                row.customer?.primaryContactName
                              )}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              align="center"
                            >
                              {row.customer?.companyId}
                            </TableCell>

                            <TableCell align="center">
                              {row.totalOrder}
                            </TableCell>
                            <TableCell align="center">
                              {row.totalShipment}
                            </TableCell>
                            <TableCell align="center">
                              {getMonthName(row.month)}
                            </TableCell>
                            <TableCell align="center">{row.year}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </>
            ) : (
              <></> // <h1 className="text-center">Loading...</h1>
            )}

            {}
          </div>
          <div
            style={{
              paddingBottom: "20px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div style={{ display: "flex" }}>
              <Select
                defaultValue="20"
                onChange={(value) => {
                  handlePageSize(value);
                  handleLoader();
                }}
                style={{
                  marginTop: "10px",
                  height: "20px",
                  marginRight: "10px",
                }}
              >
                <Option value="20">20</Option>
                <Option value="50">50</Option>
                <Option value="100">100</Option>
                <Option value="200">200</Option>
                <Option value="500">500</Option>
              </Select>
              <span
                style={{
                  marginTop: "16px",
                  color: "#808080",
                }}
              >
                Page Size
              </span>
            </div>
            <Stack spacing={2} style={{ marginTop: "20px" }}>
              <Pagination
                count={isNaN(totalPages) ? 0 : totalPages}
                page={currentPage}
                variant="outlined"
                onChange={handlePageChange}
                // onClick={() => handleLoader()}
                color="primary"
              />
            </Stack>{" "}
          </div>
        </div>

        <div className="main-footer text-center">
          <div className="container">
            <div className="row row-sm">
              <div className="col-md-12">
                <span>
                  Copyright © 2024 <a href="">Fship</a>. Developed by{" "}
                  <a href="http://fship.in/">FSHIP</a> All rights reserved.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MonthlyData;
